import env from "../../environment";
import { token } from "../auth";
import { apiPath } from "./apiPath";

/**
 * Wraps a native fetch call with some predefined headers and
 * a resolved API path (if using a relative URL).
 *
 * @example
 * makeAuthedRequest("/example/items", { method: "get" })
 *  .then(res => {
 *    // Do something with res
 *  });
 *
 * @param input - The path or URL to request.
 * @param init - Options object forwarded to `fetch` function.
 * @param fetchFunc - A fetch-compatible function to make the request. Injectable for testing purposes.
 */
export function makeAuthedRequest(input, init = {}, fetchFunc = fetch) {
  let path = input instanceof URL ? input.toString() : input;
  let headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Resolve relative paths
  path = apiPath(path, env.apiBase);

  // Add credentials if we're going to our API
  if (new URL(path).basename === new URL(env.apiBase).basename) {
    headers["wwg-token"] = token;
  }

  // Make the request with some preset headers.
  return fetchFunc(path, {
    ...init,
    headers: {
      ...headers,
      ...(init.headers || {}),
    },
  });
}
